import React from "react";
import { Link } from "react-router-dom";

import styles from "./Tabs.module.scss";

const Tabs = ({ tabs, page }) => {
  return (
    <div className={styles.tabs}>
      {tabs.map((list, index) => {
        return (
          <Link key={index} to={list.to}>
            <div
              className={
                page === list.label ? styles.activeTab : styles.inactiveTab
              }
            >
              <span>{list.label}</span>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default Tabs;
